import { Box, CircularProgress } from '@mui/material';
import { WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';
const JDGeneratorLoadingDialog = () => (
  <Box textAlign="center" pt={4}>
    <CircularProgress disableShrink sx={{ color: WsColors.Green500 }} />
    <WsTypography variant={WsTypoVariants.TITLE} bold>
      Generating Job Description
    </WsTypography>
    <WsTypography color={WsTypoColors.TERTIARY} variant={WsTypoVariants.SUB_TITLE}>
      Hold on tight for a few seconds while we work on our magic and generate job description from
      the details provided.
    </WsTypography>
  </Box>
);

export default JDGeneratorLoadingDialog;
